/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Commodities,
  CommoditiesParams,
  Commodity,
  CommodityInput,
  FilterOption,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create Commodity
 */
export const createCommodity = (
    commodityInput: MaybeRefOrGetter<CommodityInput>,
 signal?: AbortSignal
) => {
      commodityInput = toValue(commodityInput);

      return axiosClient<Commodity>(
      {url: `/commodities`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: commodityInput, signal
    },
      );
    }




export const getCreateCommodityMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCommodity>>, TError,{data: CommodityInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCommodity>>, TError,{data: CommodityInput}, TContext> => {

const mutationKey = ['createCommodity'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCommodity>>, {data: CommodityInput}> = (props) => {
          const {data} = props ?? {};

          return  createCommodity(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCommodityMutationResult = NonNullable<Awaited<ReturnType<typeof createCommodity>>>
    export type CreateCommodityMutationBody = CommodityInput
    export type CreateCommodityMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Create Commodity
 */
export const useCreateCommodity = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCommodity>>, TError,{data: CommodityInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createCommodity>>,
        TError,
        {data: CommodityInput},
        TContext
      > => {
      return useMutation(getCreateCommodityMutationOptions(options), queryClient);
    }
    /**
 * @summary Commodities list
 */
export const commodities = (
    params?: MaybeRefOrGetter<CommoditiesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Commodities>(
      {url: `/commodities`, method: 'GET',
        params, signal
    },
      );
    }




export const getCommoditiesQueryKey = (params?: MaybeRefOrGetter<CommoditiesParams>,) => {
    return [
    'commodities', ...(params ? [params] : [])
    ] as const;
    }


export const getCommoditiesQueryOptions = <TData = Awaited<ReturnType<typeof commodities>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<CommoditiesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commodities>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCommoditiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof commodities>>> = ({ signal }) => commodities(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof commodities>>, TError, TData>
}

export type CommoditiesQueryResult = NonNullable<Awaited<ReturnType<typeof commodities>>>
export type CommoditiesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Commodities list
 */

export function useCommodities<TData = Awaited<ReturnType<typeof commodities>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<CommoditiesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commodities>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommoditiesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Commodity types
 */
export const commodityTypes = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOption[]>(
      {url: `/commodities/type_filters`, method: 'GET', signal
    },
      );
    }




export const getCommodityTypesQueryKey = () => {
    return [
    'commodities','type_filters'
    ] as const;
    }


export const getCommodityTypesQueryOptions = <TData = Awaited<ReturnType<typeof commodityTypes>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commodityTypes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCommodityTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof commodityTypes>>> = ({ signal }) => commodityTypes(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof commodityTypes>>, TError, TData>
}

export type CommodityTypesQueryResult = NonNullable<Awaited<ReturnType<typeof commodityTypes>>>
export type CommodityTypesQueryError = ErrorType<StandardError>


/**
 * @summary Commodity types
 */

export function useCommodityTypes<TData = Awaited<ReturnType<typeof commodityTypes>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commodityTypes>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommodityTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Commodity
 */
export const destroyCommodity = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Commodity>(
      {url: `/commodities/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyCommodityMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyCommodity>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyCommodity>>, TError,{id: string}, TContext> => {

const mutationKey = ['destroyCommodity'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyCommodity>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyCommodity(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyCommodityMutationResult = NonNullable<Awaited<ReturnType<typeof destroyCommodity>>>

    export type DestroyCommodityMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Destroy Commodity
 */
export const useDestroyCommodity = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyCommodity>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyCommodity>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDestroyCommodityMutationOptions(options), queryClient);
    }
    /**
 * @summary Commodity Detail
 */
export const commodity = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Commodity>(
      {url: `/commodities/${id}`, method: 'GET', signal
    },
      );
    }




export const getCommodityQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'commodities',id
    ] as const;
    }


export const getCommodityQueryOptions = <TData = Awaited<ReturnType<typeof commodity>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commodity>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCommodityQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof commodity>>> = ({ signal }) => commodity(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof commodity>>, TError, TData>
}

export type CommodityQueryResult = NonNullable<Awaited<ReturnType<typeof commodity>>>
export type CommodityQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Commodity Detail
 */

export function useCommodity<TData = Awaited<ReturnType<typeof commodity>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commodity>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommodityQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Commodity
 */
export const updateCommodity = (
    id: MaybeRefOrGetter<string>,
    commodityInput: MaybeRefOrGetter<CommodityInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
commodityInput = toValue(commodityInput);

      return axiosClient<Commodity>(
      {url: `/commodities/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: commodityInput, signal
    },
      );
    }




export const getUpdateCommodityMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCommodity>>, TError,{id: string;data: CommodityInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateCommodity>>, TError,{id: string;data: CommodityInput}, TContext> => {

const mutationKey = ['updateCommodity'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCommodity>>, {id: string;data: CommodityInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCommodity(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCommodityMutationResult = NonNullable<Awaited<ReturnType<typeof updateCommodity>>>
    export type UpdateCommodityMutationBody = CommodityInput
    export type UpdateCommodityMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update Commodity
 */
export const useUpdateCommodity = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCommodity>>, TError,{id: string;data: CommodityInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateCommodity>>,
        TError,
        {id: string;data: CommodityInput},
        TContext
      > => {
      return useMutation(getUpdateCommodityMutationOptions(options), queryClient);
    }
